import styled from '@mui/material/styles/styled.js'

// NOTE: Elements in this file are intended to make standard DOM elements easy
// to style with MUI's sx prop.
// @see: https://mui.com/system/styled/
// @see: https://mui.com/system/getting-started/the-sx-prop/

export const Span = styled('span')({})
export const Div = styled('div')({})
export const P = styled('p')({})
export const Ol = styled('ol')({})
export const Ul = styled('ul')({})
export const Li = styled('li')({})
export const Img = styled('img')({})
export const Form = styled('form')({})
export const Header = styled('header')({})
export const H3 = styled('h3')({})
export const A = styled('a')({})
